import { types, flow, applySnapshot, getSnapshot } from 'mobx-state-tree';
import { pick } from 'lodash';

import { makeRequest } from 'js/services/Network';
import { isCheckoutName, isPhoneNumber } from 'js/services/Regex';
import User from 'js/stores/types/User';
import {default as AppUser} from 'js/stores/AppUser';
export default types
  .model('UserDetails', {
    isSaving: false,
    isUploading: false,
    wasSubmitted: false,
    modalIsVisible: false,
    error: types.maybeNull(types.string),
    user: types.optional(User, {}),
  })
  .views(self => ({
    get canSave() {
      return !!self.user.name && self.user.address.hasAddress && !!(self.user.phone_number || '').match(isPhoneNumber);
    },
    get canUpdateLogin() {
      return !!self.user.login && !!(self.user.login || '').match(isCheckoutName);
    },
    get hasAddressError() {
      return !self.user.address.hasAddress && self.wasSubmitted;
    },
  }))
  .actions(self => ({
    setWasSubmitted(wasSubmitted = true) {
      self.wasSubmitted = wasSubmitted;
      return self;
    },
    clearError() {
      self.error = null;
      return self;
    },
    showModal() {
      self.modalIsVisible = true;
      return self;
    },
    closeModal() {
      self.modalIsVisible = false;
      return self;
    },
    onComplete(data) {
      self.modalIsVisible = false;
      applySnapshot(self, { ...getSnapshot(self), ...data });
      return self;
    },

    save: flow(function* save() {
      let response = null;
      if (!self.isSaving && self.canSave) {
        self.clearError();
        self.isSaving = true;
        try {
          response = yield makeRequest('user-save', null, pick(self.user, ['name', 'phone_number', 'login', 'address', 'notification_method']));
        } catch (error) {
          self.error = error.response
            ? error.response.data.message || error.response.statusText
            : 'Unknown error occurred';
          self.isSaving = false;
          throw error;
        }
        self.isSaving = false;
      }
      return response ? response.data : null;
    }),
    updateLogin: flow(function* updateLogin() {
      let response = null;
      if (!self.isSaving && self.canUpdateLogin) {
        self.clearError();
        self.isSaving = true;
        try {
          response = yield makeRequest('update-login', null, pick(self.user, ['login']));
        } catch (error) {
          self.error = error.response
            ? error.response.data.message || error.response.statusText
            : 'Unknown error occurred';
          self.isSaving = false;
          throw error;
        }
        self.isSaving = false;
      }
      return response ? response.data : null;
    }),

    uploadAvatar: flow(function* (file) {
      if (!self.isUploading) {
        self.isUploading = true;
        try {
          const formData = new FormData();
          formData.append('avatar', file);

          const response = yield makeRequest('change-avatar', null, formData,'POST');

          AppUser.setAvatar(response.data.avatar);

        } catch (error) {
          self.isUploading = false;

          self.uploadError = error.response
            ? error.response.data.message || error.response.statusText
            : 'Unknown error occurred';
          throw error;
        } finally {
          self.isUploading = false;
        }
      }
    }),

  }));
